(() => {
  const update = () => {
    document.querySelectorAll('.product-card-wrapper variant-swatch-king .swatch-view').forEach(list => {
      const items = Array.from(list.children).filter(item => item.classList.contains('swatch-view-item'));
      const existing = list.querySelector('.la-card-more');
      if (items.length <= 3) { if (existing) existing.remove(); return; }
      if (existing) return;
      const card = list.closest('.product-card-wrapper');
      const productLink = card.querySelector('.card__content .card__heading a');
      if (!productLink) return;
      const item = document.createElement('li');
      item.className = 'la-card-more';
      const link = document.createElement('a');
      link.href = productLink.href;
      link.textContent = '+';
      link.setAttribute('aria-label', productLink.textContent.trim() + ' (' + items.length + ')');
      item.appendChild(link);
      list.appendChild(item);
    });
  };
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
  new MutationObserver(schedule).observe(document.documentElement, {childList:true, subtree:true});
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', schedule);
  update();
})();